import { useNavigate } from 'react-router-dom';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Lock, Crown, Coins } from 'lucide-react';

export const sevBadge = { critical: 'border-red-500/30 text-red-500 bg-red-500/10', high: 'border-orange-500/30 text-orange-500 bg-orange-500/10', medium: 'border-yellow-500/30 text-yellow-500 bg-yellow-500/10', low: 'border-green-500/30 text-green-500 bg-green-500/10' };

export const CostBadge = ({ cost }) => (
  <Badge variant="outline" className="ml-2 gap-1 border-amber-500/30 text-amber-500 bg-amber-500/10 text-[10px]" data-testid="cost-badge"><Coins className="h-3 w-3" /> {cost} cr</Badge>
);

export const ScoreRing = ({ score, label }) => {
  const color = score >= 75 ? 'text-green-500' : score >= 50 ? 'text-yellow-500' : 'text-red-500';
  return (
    <div className="text-center" data-testid="score-ring">
      <div className={`text-4xl font-bold font-heading ${color}`}>{score}</div>
      <p className="text-xs text-muted-foreground">{label}</p>
    </div>
  );
};

export const UpgradeGate = () => {
  const navigate = useNavigate();
  return (
    <Card className="border-primary/40 bg-primary/5" data-testid="org-upgrade-gate">
      <CardContent className="p-6 flex flex-col md:flex-row items-center gap-5">
        <div className="p-3 rounded-2xl bg-primary/10"><Lock className="h-8 w-8 text-primary" /></div>
        <div className="flex-1 text-center md:text-left">
          <p className="font-semibold">Organizational Security requires Premium or above</p>
          <p className="text-sm text-muted-foreground mt-0.5">Entra ID posture, HLD/LLD architecture reviews and Security Assurance assessments are available on Premium, AI Pro and Enterprise plans.</p>
        </div>
        <Button className="gap-2" onClick={() => navigate('/pricing')} data-testid="org-upgrade-btn"><Crown className="h-4 w-4" /> Upgrade plan</Button>
      </CardContent>
    </Card>
  );
};

export const handleApiError = (err, toast, navigate) => {
  const detail = err.response?.data?.detail || 'Request failed';
  if (err.response?.status === 403) toast.error(detail, { action: { label: 'Upgrade', onClick: () => navigate('/pricing') } });
  else toast.error(detail);
};
